import type { MapboxSourceConfig, TilesConfig } from '~/store2/layers.data';
import { TOCLegendParentMap } from '~/store2/TOCLayers';

/** Section heading the map legend shows for a tile layer. */
export const getLegendHeading = (config: MapboxSourceConfig) => TOCLegendParentMap.get(config.id) || config.name;

/** The legend heading of each tile layer among `sourceIds`, keyed by source id. */
export const getLegendHeadings = (sourceIds: string[], tilesConfig: TilesConfig | undefined): Record<string, string> =>
  Object.fromEntries(
    sourceIds.flatMap((id) => {
      const config = tilesConfig?.[id];
      return config ? [[id, getLegendHeading(config)]] : [];
    }),
  );
